import { useTranslation } from 'react-i18next';
import { Pill } from '../ui';
import type { FeedRestaurant } from '../../types/feed';
import { usePwaNav } from '../../contexts/PwaNavContext';
import './RestaurantFeedCard.css';

export function RestaurantFeedCard({ r }: { r: FeedRestaurant }) {
  const { t } = useTranslation();
  const { navigate } = usePwaNav();
  const distance =
    r.distanceKm == null
      ? null
      : r.distanceKm < 1
        ? t('feed.distanceM', { n: Math.round(r.distanceKm * 1000) })
        : t('feed.distanceKm', { n: r.distanceKm.toFixed(1) });

  return (
    <button
      type="button"
      onClick={() => navigate(`/r/${r.slug}`)}
      className={`rfc${r.isFeatured ? ' rfc--featured' : ''}${!r.openNow ? ' rfc--closed' : ''}`}
      aria-label={`${r.name}${r.cuisine ? ' — ' + t(`cuisine.${r.cuisine}`) : ''}`}
    >
      <div className="rfc-cover">
        {r.coverImageUrl ? (
          <img src={r.coverImageUrl} alt="" className="rfc-cover-img" />
        ) : (
          <div className="rfc-cover-fallback" role="img" aria-label={r.name}>
            <span className="rfc-cover-fallback-name">{r.name}</span>
          </div>
        )}
        <div className="rfc-cover-overlay" />
        <div className="rfc-cover-bottom">
          {r.logoUrl && <img src={r.logoUrl} alt="" className="rfc-logo" />}
          <div className="rfc-cover-title">
            <div className="rfc-name">{r.name}</div>
            {r.cuisine && <Pill tone="neutral">{t(`cuisine.${r.cuisine}`)}</Pill>}
          </div>
        </div>
      </div>
      <div className="rfc-meta">
        <Pill tone={r.openNow ? 'green' : 'neutral'}>
          {r.openNow
            ? t('feed.open')
            : r.opensAt
              ? t('feed.closedOpensAt', { time: r.opensAt })
              : t('feed.closed')}
        </Pill>
        {distance && <span className="rfc-distance">{distance}</span>}
        {r.ordersToday > 0 && (
          <span className="rfc-social">{t('feed.ordersToday', { n: r.ordersToday })}</span>
        )}
      </div>
    </button>
  );
}
